import { captureException } from '@sentry/react'
import { createRoot } from 'react-dom/client'

import { App } from 'App/App'
import { setupAxios } from 'App/setupAxios'
import { setupSentry } from 'App/setupSentry'
import { Auth, permissions } from 'common/auth/auth'
import { AuthenticatedUser } from 'common/auth/authUser'
import { IDaveAuthenticatedUser } from 'modules/Monitoring/types'

const userDetails = await Auth.init()

if (userDetails) {
  try {
    await permissions.init()

    AuthenticatedUser.setUser(userDetails as IDaveAuthenticatedUser)

    setupAxios()
    setupSentry()

    if (process.env.REACT_APP_MOCK_SERVICE_WORKER === 'true') {
      const { startMockWorker } = await import('@revolut-internal/simcoe')
      const { swMocks } = await import('modules/Monitoring/testing/apiMocks')
      await startMockWorker(swMocks)
    }

    const container = document.getElementById('mount')

    if (!container) {
      throw new Error('Cannot find #mount element to mount react app')
    }

    const root = createRoot(container)
    root.render(<App />)
  } catch (e) {
    captureException(e)
  }
}
